
import React from 'react';
import SliderMain from './SliderMain';
import SchoolList from './SchoolList';
import AboutMain from './AboutMain';
import NewBulletin from './pages/FlashNews/NewsBulletin';
import Slider from './pages/Slider';
import GenInstructionCBSE from './OnlineApplication/cbseapplication/cbseApplication/GenInstructionCBSE';
import AboutProvince from './pages/home/AboutProvince';
import AnimatedSlider from './AnimatedSlider';
export default function Home() {
  return (
    <div>
      {/*<Slider />
      <SliderMain />*/}
      <AnimatedSlider />
      <NewBulletin />
      <AboutProvince />
     {/*} <AboutMain />*/}
      <SchoolList />
    </div>
  );
}
